module.exports = __webpack_public_path__ + "static/img/b6_body.ded2a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b6_body.png
// module id = BD2K
// module chunks = 1